import { FC } from 'react';
import {
  AudienceLiftContainer,
  AudienceLiftTitle,
  PrimaryNumber,
  PrimaryText,
  PrimaryWrapper,
  SecondaryText,
} from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/audienceLift/BreakdownAudienceLift.styles';
import {
  BREAKDOWN_AUDIENCE_AVERAGE_SENDS_PER_WEEK,
  BREAKDOWN_AUDIENCE_AVERAGE_SENDS_WITH_HOLDOUT,
  BREAKDOWN_AUDIENCE_AVERAGE_SENDS,
} from 'modules/intelligentInsights/constants';
import { useFroInsightsCoreContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/CoreContext';
import {
  getAvgWeeklySendsByMedium,
  getWeeklySendsByMedium,
} from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/breakdownUtils';
import { MessageMediumTab } from 'modules/intelligentInsights/frequencyOptimization/types';
import { customLocalizeNumber } from 'modules/intelligentInsights/domain.utils';

export const BREAKDOWN_AUDIENCE_AVERAGE_TEST_ID = 'breakdown-audience-average';

export type BreakdownAudienceAverageProps = {
  messageMedium: MessageMediumTab;
};

export const BreakdownAudienceAverage: FC<BreakdownAudienceAverageProps> = ({ messageMedium }) => {
  const { froInsightsData } = useFroInsightsCoreContext();
  const { weeklyOptimizedSendsPerUser } = getWeeklySendsByMedium(froInsightsData, messageMedium);
  const avgWeeklySends = getAvgWeeklySendsByMedium(froInsightsData, messageMedium);
  const sendsDiff = `${BREAKDOWN_AUDIENCE_AVERAGE_SENDS_WITH_HOLDOUT.PRENUMBER} 
  ${avgWeeklySends} ${BREAKDOWN_AUDIENCE_AVERAGE_SENDS_WITH_HOLDOUT.POSTNUMBER}`;

  return (
    <AudienceLiftContainer data-test={BREAKDOWN_AUDIENCE_AVERAGE_TEST_ID}>
      <AudienceLiftTitle>{BREAKDOWN_AUDIENCE_AVERAGE_SENDS}</AudienceLiftTitle>
      <PrimaryWrapper
        flexDirection="column"
        gap="quarter"
        alignItems="start"
        justifyContent="center"
      >
        <PrimaryNumber>{customLocalizeNumber(weeklyOptimizedSendsPerUser)}</PrimaryNumber>
        <PrimaryText>{BREAKDOWN_AUDIENCE_AVERAGE_SENDS_PER_WEEK}</PrimaryText>
      </PrimaryWrapper>
      <SecondaryText>{sendsDiff}</SecondaryText>
    </AudienceLiftContainer>
  );
};
